import { route } from '../helpers';

import { NewsletterPages } from '../../constants/AppConstants';

export default route(NewsletterPages.UNSUBSCRIBE, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/newsletter/Unsubscribe').default);
        }, 'newsletter-unsubscribe');
    }
});
